module.exports = __webpack_public_path__ + "static/tpp-image03-df4040a99da4542b539c8431cabc726f.png";